const { angular } = window;

angular.module('wcm.exportButton', []);
